import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  showNotification(
    message: string,
    action: string,
    type: string = 'info',
    duration: number = 2000
  ) {
    this.snackBar.open(message, action, {
      duration,
      panelClass: ['custom-snackbar', type],
      horizontalPosition: 'end',
      verticalPosition: 'bottom',
    });
  }
}
